import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "o-propertyFloorplan"
}
const _hoisted_2 = { class: "o-propertyFloorplan__content" }
const _hoisted_3 = { class: "o-propertyFloorplan__floorplanImage" }
const _hoisted_4 = { class: "o-propertyFloorplan__floorplanImage__container" }
const _hoisted_5 = {
  key: 1,
  ref: "floorplanImage",
  alt: "",
  width: "4000",
  height: "4000",
  draggable: "false",
  sizes: "(min-width: 1024px) 60vw, (min-width: 1600px) 780px, 72vw"
}
const _hoisted_6 = {
  ref: "floorplanImage",
  alt: "",
  width: "4000",
  height: "4000",
  draggable: "false",
  sizes: "(min-width: 1024px) 60vw, (min-width: 1600px) 780px, 72vw"
}
const _hoisted_7 = ["data-index"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "innerangle" }, null, -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { ref: "hotspotImages" }
const _hoisted_11 = { class: "o-propertyFloorplan__hotspotImages" }
const _hoisted_12 = {
  ref: "hotspotImageList",
  class: "o-propertyFloorplan__hotspotImageList"
}
const _hoisted_13 = ["id", "src"]
const _hoisted_14 = { class: "o-propertyFloorplan__hotspotButtonsWrapper" }
const _hoisted_15 = { class: "o-propertyFloorplan__hotspotButtons" }
const _hoisted_16 = {
  key: 0,
  class: "o-propertyFloorplan__options"
}
const _hoisted_17 = ["textContent"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  class: "o-propertyFloorplan__floors"
}
const _hoisted_20 = ["value"]
const _hoisted_21 = ["textContent"]
const _hoisted_22 = {
  key: 2,
  class: "m-select floorplanSelect"
}
const _hoisted_23 = { class: "m-select__wrapper" }
const _hoisted_24 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_loader = _resolveComponent("m-loader")!
  const _component_a_icon = _resolveComponent("a-icon")!
  const _component_m_multi_toggle = _resolveComponent("m-multi-toggle")!

  return ($data.types.length > 0 && $data.floorplanOptions.options.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              ($data.isLoading)
                ? (_openBlock(), _createBlock(_component_m_loader, { key: 0 }))
                : _createCommentVNode("v-if", true),
              ($data.currentType === 'interactive' || !$data.isDesktop)
                ? (_openBlock(), _createElementBlock("img", _hoisted_5, null, 512 /* NEED_PATCH */))
                : (_openBlock(), _createElementBlock("figure", {
                    key: 2,
                    class: _normalizeClass(["zoom", [
                            $data.isZoomed ? 'is-zoomed' : '',
                            $data.imageError ? 'no-image' : '',
                        ]]),
                    style: _normalizeStyle({
                            backgroundImage:
                                'url(' + $data.floorplanOptions.selectedItem + ')',
                        }),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.isZoomed = !$data.isZoomed)),
                    onMousemove: _cache[1] || (_cache[1] = (event) => $options.zoom(event))
                  }, [
                    _createElementVNode("img", _hoisted_6, null, 512 /* NEED_PATCH */)
                  ], 38 /* CLASS, STYLE, NEED_HYDRATION */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.hotspots, (hotspot, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  type: "button",
                  key: index,
                  "data-index": index,
                  style: _normalizeStyle({
                            left: hotspot.data.x + '%',
                            top: hotspot.data.y + '%',
                        }),
                  class: _normalizeClass({ isActive: $data.hotspotIndex === index }),
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.hotspotClick && $options.hotspotClick(...args)))
                }, [
                  _withDirectives(_createElementVNode("div", {
                    class: "outerangle",
                    style: _normalizeStyle({ '--deg': `${hotspot.data.deg}deg` })
                  }, _hoisted_9, 4 /* STYLE */), [
                    [_vShow, $options.showHotspotDirection(index)]
                  ])
                ], 14 /* CLASS, STYLE, PROPS */, _hoisted_7))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("ul", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.hotspots, (hotspot, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: hotspot.id
                  }, [
                    _createElementVNode("img", {
                      id: `hotspot-${index}`,
                      src: hotspot.file,
                      alt: ""
                    }, null, 8 /* PROPS */, _hoisted_13)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.prevHotspot && $options.prevHotspot(...args))),
                  "aria-label": "Forrige billede"
                }, [
                  _createVNode(_component_a_icon, { name: "arrow_back" })
                ]),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($options.nextHotspot && $options.nextHotspot(...args))),
                  "aria-label": "Næste billede"
                }, [
                  _createVNode(_component_a_icon, { name: "arrow_forward" })
                ])
              ])
            ])
          ], 512 /* NEED_PATCH */), [
            [_vShow, $data.imagesActive]
          ])
        ]),
        ($options.showOptionsBox)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("h2", {
                class: "o-propertyFloorplan__headline",
                textContent: _toDisplayString($props.headline)
              }, null, 8 /* PROPS */, _hoisted_17),
              ($options.showMultiToggle)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createVNode(_component_m_multi_toggle, {
                      items: $data.types,
                      onChange: $options.changeType
                    }, null, 8 /* PROPS */, ["items", "onChange"])
                  ]))
                : _createCommentVNode("v-if", true),
              ($data.isDesktop && $data.floorplanOptions.options.length > 0)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.floorplanOptions.options, (floorplan) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: floorplan.guid
                      }, [
                        _createElementVNode("label", null, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.floorplanOptions.selectedItem) = $event)),
                            type: "radio",
                            value: floorplan.value,
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($options.changeFloorplan && $options.changeFloorplan(...args)))
                          }, null, 8 /* PROPS */, _hoisted_20), [
                            [_vModelRadio, $data.floorplanOptions.selectedItem]
                          ]),
                          _createElementVNode("span", {
                            textContent: _toDisplayString(floorplan.label)
                          }, null, 8 /* PROPS */, _hoisted_21)
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true),
              (!$data.isDesktop && $data.floorplanOptions.options.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.floorplanOptions.selectedItem) = $event)),
                        onChange: _cache[8] || (_cache[8] = ($event: any) => ($options.swapImage($data.floorplanOptions.selectedItem))),
                        class: "a-select m-select__field m-select__field--visible"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.floorplanOptions.options, (option) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: option.value
                          }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_24))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                        [_vModelSelect, $data.floorplanOptions.selectedItem]
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}